import { GET_ADDITIFS } from "../actions/additifs.actions";

const initialState = {};

export default function additifsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ADDITIFS:
      return action.payload;
    default:
      return state;
  }
}
